// hooks/useItemSearch.js
import { useEffect, useState } from "react";
import Fuse from "fuse.js";
import axios from "axios";

const fuseOptions = {
  keys: ["name", "id"],
  threshold: 0.3,
  includeMatches: true, // Changed from includeScore to includeMatches
};

const useItemSearch = () => {
  const [fuse, setFuse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("https://api.pixelore.wiki/api/item-search")
      .then((res) => {
        setFuse(new Fuse(res.data, fuseOptions));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch items", err);
        setLoading(false);
      });
  }, []);

  const searchItems = (query) => {
    if (!fuse || !query.trim()) return [];
    return fuse.search(query);
  };

  return { searchItems, loading };
};

export default useItemSearch;